import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SaleItemModel } from '../model/sale-item.model';
import { SaleItemService } from '../sale-item.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { GroupItemEditPopupComponent } from '../group-item-edit-popup/group-item-edit-popup.component';
import { PermissionService } from 'src/app/auth/permission.service';
@Component({
  selector: 'app-sale-item-edit',
  templateUrl: './sale-item-edit.component.html',
  styleUrl: './sale-item-edit.component.scss',
  standalone: false
})
export class SaleItemEditComponent implements DirtyCheck, OnInit {
  @ViewChild('input') input!: ElementRef<HTMLInputElement>;

  myControl = new FormControl('');
  title: string = "New Sale Item";
  editForm: FormGroup;
  saleItemInfo: SaleItemModel = {};
  isFormDirty: boolean = false;
  isMultiColorChecked: boolean = false;
  isSecondColorEditable!: boolean;
  stock_item_id: any[] = [];
  kitchen_id: any;
  item_classes_id: any;
  tax_id: any;
  selectedValue!: string;
  selectedCode!: string;
  selectedStock: any;
  filteredOptions: any[] = [];
  selectedId: any;
  kitchen: any;
  tax: any;
  itemClasses: any;
  itemTypes: any[] = [];
  permission: any;

  optionNameControl: FormControl[] = [];
  filteredOptionNames: Observable<string[]>[] = [];
  saleItemsCustomization: any[] = [];
  saleItemsCombo: any[] = [];
  filteredSaleItems: Observable<any[]>[] = [];
  groupItems: any[] = [];
  copyItems: any[] = [];
  copyItemControl = new FormControl<any>(null);
  filteredCopyItems: Observable<any[]> = new Observable();

  // Autocomplete controls for dropdowns
  groupItemControl = new FormControl<any>(null);
  filteredGroupItems: Observable<any[]> = new Observable();

  taxControl = new FormControl<any>(null);
  filteredTax: Observable<any[]> = new Observable();

  uomControl = new FormControl<any>(null);
  filteredUom: Observable<any[]> = new Observable();

  kitchenControl = new FormControl<any>(null);
  filteredKitchen: Observable<any[]> = new Observable();
isShopPriceDefined: boolean = false;
  // Combo options autocomplete
  filteredComboOptions: any[] = [];

  displayedColumns = ['label', 'hot1', 'hot2', 'hot3', 'dt'];
  hotItems = [
    { label: 'Enabled', type: 'enabled' },
    { label: 'Display Order', type: 'order' },
    { label: 'Menu Number', type: 'menu' }
  ];

  hotItem1 = { enabled: false, displayOrder: null as number | null, menuNumber: null as number | null };
  hotItem2 = { enabled: false, displayOrder: null as number | null, menuNumber: null as number | null };
  hotItem3 = { enabled: false, displayOrder: null as number | null, menuNumber: null as number | null };
  dt = { enabled: false, displayOrder: null as number | null, menuNumber: null as number | null };

  optionNames: string[] = ['Option 1', 'Option 2', 'Option 3'];
  customizationOptions: any[] = [
    {
      optionName: '',
      displayName: '',
      defaultOptions: '',
      display_order: 1,
      is_valid: true
    }
  ];

  comboOptions: any[] = [];
  availableComboOptions: any[] = [];
  uomList: any;

  tempCustomizationOptions: any[] | null = null;
  tempComboOptions: any[] | null = null;
  userData: any;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private saleItemService: SaleItemService,
    private snackBarService: SnackBarService,
    public dialog: MatDialog, private permissionService: PermissionService
  ) {
     const userDetailsData = sessionStorage.getItem('user');
    if (userDetailsData) {
      this.userData = JSON.parse(userDetailsData);
    }
    let saleItemId = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: [this.saleItemInfo.code, [Validators.required, Validators.maxLength(10)]],
      name: [this.saleItemInfo.name, [Validators.required, Validators.maxLength(50)]],
      short_name: [this.saleItemInfo.short_name],
      alternative_name: [this.saleItemInfo.alternative_name],
      name_to_print: [this.saleItemInfo.name_to_print],
      alternative_name_to_print: [this.saleItemInfo.alternative_name_to_print],
      description: [this.saleItemInfo.description],
      barcode: [this.saleItemInfo.barcode],
      sub_class_id: [this.saleItemInfo.sub_class_id, [Validators.required]],
      item_type: [this.saleItemInfo.item_type ?? 1, [Validators.required]],
      fixed_price: [this.saleItemInfo.fixed_price, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      shop_price: [this.saleItemInfo.shop_price, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      is_open: [this.saleItemInfo.is_open ?? false],
      item_cost: [this.saleItemInfo.item_cost, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      is_direct_sale_allowed: [this.saleItemInfo.is_direct_sale_allowed ?? true],
      is_oo_direct_sale_allowed: [this.saleItemInfo.is_oo_direct_sale_allowed ?? true],
      fg_color: [this.saleItemInfo.fg_color ?? '#FFFFFF'],
      bg_color: [this.saleItemInfo.bg_color ?? '#A9A9A9'],
      use_multi_color: [this.saleItemInfo.use_multi_color ?? false],
      bg_color2: [this.saleItemInfo.bg_color2 ?? '#A9A9A9'],
      is_require_weighing: [this.saleItemInfo.is_require_weighing],
      is_hot_item_1: [this.saleItemInfo.is_hot_item_1],
      hot_item_1_display_order: [this.saleItemInfo.hot_item_1_display_order, [Validators.pattern(/^[0-9]*$/)]],
      is_hot_item_2: [this.saleItemInfo.is_hot_item_2],
      hot_item_2_display_order: [this.saleItemInfo.hot_item_2_display_order, [Validators.pattern(/^[0-9]*$/)]],
      is_hot_item_3: [this.saleItemInfo.is_hot_item_3],
      hot_item_3_display_order: [this.saleItemInfo.hot_item_3_display_order, [Validators.pattern(/^[0-9]*$/)]],
      is_dt_item: [this.saleItemInfo.is_dt_item],
      dt_display_order: [this.saleItemInfo.dt_display_order, [Validators.pattern(/^[0-9]*$/)]],
      dt_menu_number: [this.saleItemInfo.dt_menu_number, [Validators.pattern(/^[0-9]*$/)]],
      kitchen_id: [this.saleItemInfo.kitchen_id],
      uom_id: [this.saleItemInfo.uom_id, [Validators.required]],
      tax_id: [this.saleItemInfo.tax_id, [Validators.required]],
      is_valid: [this.saleItemInfo.is_valid ?? true],
      group_item_id: [this.saleItemInfo.group_item_id ?? null],
      print_on_demand: [this.saleItemInfo.print_on_demand]
    });

    if (this.saleItemInfo.stock_item_id) {
      this.editForm.get('stock_item_id')?.setValue(this.saleItemInfo.stock_item_id);
    }

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (saleItemId !== null && parseInt(saleItemId) !== 0) {
      this.setSaleItemInfo(saleItemId);
    } else {
      // For new items, setup hot item controls after a brief delay to allow data loading
      setTimeout(() => {
        this.setupInitialHotItemControlStates();
        this.enableHotItemControls(); // Ensure hot items are enabled for new items
      }, 100); // Reduced timeout for faster response
    }
    this.onGroupItemSelected({ value: null });
    this.permission = permissionService.getPagePermission('sale-item');
  }

  ngOnInit() {
    // this.loadStockList();
    this.loadKitchenList();
    this.loaditemClassesList(); // Load all item classes at initialization
    this.loadTaxList();
    this.loadUomList();
    this.loadComboOptions();
    this.loadGroupItems();

    this.myControl.valueChanges.subscribe(() => {
      this.filter();
    });
    this.itemTypes = [
      { id: 1, name: 'Regular item' },
      { id: 2, name: 'Customizable item' },
      { id: 3, name: 'Combo item' }
    ];

    // Try to load customization data from session storage first
    const storedCustomization = sessionStorage.getItem('customizationData');
    if (storedCustomization) {
      this.saleItemsCustomization = JSON.parse(storedCustomization);
      // If customizationOptions were loaded before saleItemsCustomization, bind now
      if (this.tempCustomizationOptions) {
        this.bindCustomizationOptions(this.tempCustomizationOptions);
        this.tempCustomizationOptions = null;
      }
    } else {
      // Fallback to API call if not in session storage
      let requestData = {
        search: {
          filters: {
            simpleSearch: [],
            advSearch: [],
            scope: {
              limit: 50,
              offset: 0
            }
          },
          sort: []
        }
      };
      this.saleItemService.getCustomizationList(requestData).subscribe((response: any) => {
        if (response.status === 'SUCCESS') {
          this.saleItemsCustomization = response.data.customizations;
          // Store in session storage for future use
          sessionStorage.setItem('customizationData', JSON.stringify(this.saleItemsCustomization));

          if (this.tempCustomizationOptions) {
            this.bindCustomizationOptions(this.tempCustomizationOptions);
            this.tempCustomizationOptions = null;
          }
        }
      });
    }

    // this.saleItemService.getComboList(requestData).subscribe((response: any) => {
    //   if (response.status === 'SUCCESS') {
    //     this.saleItemsCombo = response.data.combo_options || [];
    //     console.log('Loaded combo options:', this.saleItemsCombo);
    //     // If combo options were loaded before saleItemsCombo, bind now
    //     if (this.tempComboOptions) {
    //       this.bindComboOptions(this.tempComboOptions);
    //       this.tempComboOptions = null;
    //     }
    //   }
    // });
    // Initialize optionNameControl and filteredSaleItems for customizationOptions
    this.customizationOptions.forEach((opt, i) => {
      this.optionNameControl[i] = new FormControl(opt.optionName);
      this.filteredSaleItems[i] = this.optionNameControl[i].valueChanges.pipe(
        startWith(''),
        map(value => this._filterSaleItems(value || '')),
      );
    });


  }

  onInputBlur(): void {
    // Add any additional logic you need on blur
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedStockName = event.option.value;
    this.selectedStock = this.stock_item_id.find((stock: { name: string; code: string; id: string }) => stock.name === selectedStockName);

    if (this.selectedStock) {
      this.selectedCode = this.selectedStock.code;
      this.selectedId = this.selectedStock.id;
      this.myControl.setValue(this.selectedStock.name);
      this.editForm.get('stock_item_id')?.setValue(this.selectedStock.id);
    }
  }

  onOptionNameSelected(event: any, i: number) {
    const selectedId = event.option.value;
    const selectedItem = this.saleItemsCustomization.find(item => item.id === selectedId);
    if (selectedItem) {
      this.customizationOptions[i].customization_option_id = selectedItem.id;
      this.customizationOptions[i].displayName = selectedItem.display_name || selectedItem.name;
      this.customizationOptions[i].option_for = selectedItem.option_for || '';
      if (!this.customizationOptions[i].defaultOptions) {
        this.customizationOptions[i].defaultOptions = selectedItem.option_value_name || '';
      }
    }
  }

  displayStockItem(stock: { name: string, id: string } | null): string {
    return stock ? stock.name : '';
  }

  trackById(index: number, stock: { id: string; }): string {
    return stock.id;
  }

  filter(): void {
    const filterValue = this.myControl.value?.toLowerCase() || '';
    this.filteredOptions = this.stock_item_id.filter((stock: any) =>
      stock.name.toLowerCase().includes(filterValue)
    );
  }

  toggleColorInput(checked: boolean): void {
    this.isMultiColorChecked = checked;
    this.isSecondColorEditable = checked;
  }

  isDirty(): boolean {
    return this.isFormDirty;
  }

  navBack(): void {
    this.router.navigate(['/product/sale-item']);
  }

  setSaleItemInfo(saleItemId: any): void {
    const parsedShopId = parseInt(saleItemId, 10) || 0;
    this.saleItemService.getSaleItemById(parsedShopId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.saleItemInfo = response.data.item;
          this.editForm.patchValue({
            ...this.saleItemInfo,
            sub_class_id: this.saleItemInfo.sub_class_id, // Keep original value for proper binding
            item_type: Number(this.saleItemInfo.item_type)
          });
          // --- ADD THIS BLOCK TO HANDLE SHOP PRICE READONLY STATE ---
         // --- ADD THIS BLOCK TO HANDLE SHOP PRICE READONLY STATE ---
          if (this.saleItemInfo.shop_price !== null && this.saleItemInfo.shop_price !== undefined) {
            this.isShopPriceDefined = true; // Locks the input
          } else {
            this.isShopPriceDefined = false; // Enables the input
          }
          // ----------------------------------------------------------

          // Initialize multicolor checkbox after form is patched
          const multiColorControl = this.editForm.get('use_multi_color');
          this.isMultiColorChecked = multiColorControl && multiColorControl.value == 1 ? true : false;

          // Handle customization data
          if (this.saleItemInfo.customization && Array.isArray(this.saleItemInfo.customization)) {
            if (!this.saleItemsCustomization || this.saleItemsCustomization.length === 0) {
              this.tempCustomizationOptions = this.saleItemInfo.customization;
            } else {
              this.bindCustomizationOptions(this.saleItemInfo.customization);
            }
          }

          // Handle combo data
          if (this.saleItemInfo.combo && Array.isArray(this.saleItemInfo.combo)) {
            if (!this.availableComboOptions || this.availableComboOptions.length === 0) {
              this.tempComboOptions = this.saleItemInfo.combo;
            } else {
              this.bindComboOptions(this.saleItemInfo.combo);
            }
          }

          // Initialize autocomplete controls with existing values
          this.initializeAutocompleteControls();

          // Setup hot item control states after data is loaded
          this.setupInitialHotItemControlStates();
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
    
  }

  // onResetShopPrice(): void {
  //   const confirmDialog: ConfirmDialogModel = new ConfirmDialogModel(
  //     'Confirm Reset',
  //     `Do you want to reset the shop price for the item ${this.saleItemInfo.name}?`
  //   );
  //   confirmDialog.yesButtonCaption = 'Yes';
  //   confirmDialog.noButtonCaption = 'No';

  //   const dialogRef = this.dialog.open(ConfirmDialogComponent, {
  //     maxWidth: '400px',
  //     data: confirmDialog
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       /* NOTE: If you have a specific backend endpoint to soft-delete the shop price 
  //         immediately upon clicking reset, call it here. 
  //         Example: this.saleItemService.deleteShopPrice(this.saleItemInfo.id).subscribe(...)
  //       */

  //       // 1. Unlock the input field
  //       this.isShopPriceDefined = false;
        
  //       // 2. Clear the existing value so the user can type a new one
  //       this.editForm.get('shop_price')?.setValue(null);
  //       this.editForm.get('shop_price')?.markAsDirty();
        
  //       // 3. Show success message
  //       let snackBarData: SnackBarData = {
  //         type: 'success',
  //         title: 'Reset',
  //         message: 'Shop price has been reset. You can now enter a new price.'
  //       };
  //       this.snackBarService.openSnackBar(snackBarData);
  //     }
  //   });
  // }
  onResetShopPrice(): void {
    // Safety check: Don't try to reset if it's a brand new item that hasn't been saved yet
    if (!this.saleItemInfo.id) {
      this.isShopPriceDefined = false;
      this.editForm.get('shop_price')?.setValue(null);
      return;
    }

    const confirmDialog: ConfirmDialogModel = new ConfirmDialogModel(
      'Confirm Reset',
      `Do you want to reset the shop price for the item ${this.saleItemInfo.name}?`
    );
    confirmDialog.yesButtonCaption = 'Yes';
    confirmDialog.noButtonCaption = 'No';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '400px',
      data: confirmDialog
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Prepare payload with the sale item ID
        const payload = { sale_item_id: this.saleItemInfo.id };

        // Call the API
        this.saleItemService.resetShopPrice(payload).subscribe({
          next: (response: any) => {
            if (response.status === 'SUCCESS') {
              // 1. Unlock the input field
              this.isShopPriceDefined = false;
              
              // 2. Clear the existing value so the user can type a new one
              this.editForm.get('shop_price')?.setValue(null);
              this.editForm.get('shop_price')?.markAsDirty();
              
              // 3. Show success message
              let snackBarData: SnackBarData = {
                type: 'success',
                title: 'Reset',
                message: 'Shop price has been reset. You can now enter a new price.'
              };
              this.snackBarService.openSnackBar(snackBarData);
            } else {
              // Handle backend failure
              let snackBarData: SnackBarData = {
                type: 'error',
                title: 'Failed',
                message: response.message || 'Failed to reset shop price.'
              };
              this.snackBarService.openSnackBar(snackBarData);
            }
          },
          error: (error) => {
            // Handle network/server error
            let snackBarData: SnackBarData = {
              type: 'error',
              title: 'Error',
              message: 'Connection failed while resetting shop price.'
            };
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    });
  }

  bindCustomizationOptions(customizationArr: any[]) {
    this.customizationOptions = customizationArr;
    this.optionNameControl = [];
    this.filteredSaleItems = [];
    this.customizationOptions.forEach((opt, i) => {
      // Convert display_order to number if present
      if (opt.display_order !== undefined && opt.display_order !== null) {
        opt.display_order = Number(opt.display_order);
        // console.log(opt.display_order)
      }
      // Set optionNameControl to customization_option_id
      this.optionNameControl[i] = new FormControl(opt.customization_option_id || '');
      this.filteredSaleItems[i] = this.optionNameControl[i].valueChanges.pipe(
        startWith(''),
        map(value => this._filterSaleItems(value || '')),
      );
      let saleItem = this.saleItemsCustomization.find(item => String(item.id) === String(opt.customization_option_id));
      if (saleItem) {
        this.customizationOptions[i].displayName = saleItem.display_name || saleItem.name;
        this.customizationOptions[i].defaultOptions = saleItem.option_value_name;
      }
    });
    this.customizationOptions = [...this.customizationOptions];
  }

  loadComboOptions(): void {
    // Try to load combo data from session storage first
    const storedCombo = sessionStorage.getItem('comboData');
    if (storedCombo) {
      this.saleItemsCombo = JSON.parse(storedCombo);
      this.availableComboOptions = this.saleItemsCombo;

      // Initialize filtered combo options for autocomplete
      this.filteredComboOptions = this.availableComboOptions;

      // If combo options were loaded before availableComboOptions, bind now
      if (this.tempComboOptions) {
        this.bindComboOptions(this.tempComboOptions);
        this.tempComboOptions = null;
      }
    } else {
      // Fallback to API call if not in session storage
      let requestData = {
        search: {
          filters: {
            simpleSearch: [],
            advSearch: [],
            scope: {
              limit: 100,
              offset: 0
            }
          },
          sort: []
        }
      };

      this.saleItemService.getComboList(requestData).subscribe(
        (response: {
          data: any;
          status: string;
          message: any;
        }) => {
          if (response.status === "SUCCESS") {
            this.saleItemsCombo = response.data.combo_options || [];
            this.availableComboOptions = this.saleItemsCombo;

            // Initialize filtered combo options for autocomplete
            this.filteredComboOptions = this.availableComboOptions;

            // Store in session storage for future use
            sessionStorage.setItem('comboData', JSON.stringify(this.saleItemsCombo));

            if (this.tempComboOptions) {
              this.bindComboOptions(this.tempComboOptions);
              this.tempComboOptions = null;
            }
          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: "Failed!!!",
              type: "error",
            };
            this.snackBarService.openSnackBar(snackBarData);
          }
        }
      );
    }
  }

  bindComboOptions(comboArr: any[]) {
    this.comboOptions = comboArr.map(combo => {
      // Find the matching combo option to get additional details
      const matchingOption = this.availableComboOptions.find(opt => opt.combo_option_id === combo.combo_option_id);
      return {
        id: combo.id || null,
        combo_option_id: combo.combo_option_id,
        combo_option_name: matchingOption ? matchingOption.name : '',
        display_name: matchingOption ? matchingOption.display_name : '',
        option_value_name: matchingOption ? matchingOption.option_value_name : '',
        price: matchingOption ? matchingOption.price : null,
        is_percentage: matchingOption ? matchingOption.is_percentage : 0,
        price_variance: matchingOption ? matchingOption.price_variance : null,
        display_order: Number(combo.display_order) || 10,
        is_valid: combo.is_valid === 1 || combo.is_valid === true,
        is_deleted: combo.is_deleted || "0",
        discount_price: matchingOption ? matchingOption.discount_price : null
      };
    });
    // console.log('Bound combo options:', this.comboOptions); // Debug log
  }

  onComboOptionSelected(event: any, index: number) {
    const selectedOptionId = event.value;
    const selectedOption = this.availableComboOptions.find(opt => opt.combo_option_id === selectedOptionId);

    if (selectedOption) {
      this.comboOptions[index].combo_option_name = selectedOption.name;
      this.comboOptions[index].display_name = selectedOption.display_name;
      this.comboOptions[index].option_value_name = selectedOption.option_value_name;
      this.comboOptions[index].price = selectedOption.price;
      this.comboOptions[index].is_percentage = selectedOption.is_percentage;
      this.comboOptions[index].price_variance = selectedOption.price_variance;
    }
  }

  addCustomizationRow() {
    this.customizationOptions = [
      ...this.customizationOptions,
      {
        optionName: '',
        displayName: '',
        defaultOptions: '',
        display_order: '',
        is_valid: true
      }
    ];
    const idx = this.customizationOptions.length - 1;
    this.optionNameControl[idx] = new FormControl('');
    this.filteredSaleItems[idx] = this.optionNameControl[idx].valueChanges.pipe(
      startWith(''),
      map(value => this._filterSaleItems(value || '')),
    );

    // Auto-scroll to the newly added row
    setTimeout(() => {
      const scrollContainer = document.getElementById('customizationScrollContainer');
      if (scrollContainer) {
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
      }
    }, 100);
  }

  removeCustomizationRow(index: number) {
    const confirmDialog: ConfirmDialogModel = new ConfirmDialogModel(
      'Confirm Delete',
      'Are you sure you want to remove this customization option?'
    );
    confirmDialog.yesButtonCaption = 'Delete';
    confirmDialog.noButtonCaption = 'Cancel';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '400px',
      data: confirmDialog
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.customizationOptions.splice(index, 1);
        this.optionNameControl.splice(index, 1);
        this.filteredSaleItems.splice(index, 1);
        this.customizationOptions = [...this.customizationOptions];
      }
    });
  }

  addComboRow() {
    const newComboOption = {
      id: null,
      combo_option_id: null,
      combo_option_name: '',
      display_name: '',
      option_value_name: '',
      price: null,
      is_percentage: 0,
      price_variance: null,
      display_order: this.comboOptions.length > 0 ?
        Math.max(...this.comboOptions.map(c => c.display_order || 0)) + 1 : 1,
      is_valid: true,
      is_deleted: "0",
      discount_price: null
    };

    this.comboOptions = [...this.comboOptions, newComboOption];

    // Auto-scroll to the newly added row
    setTimeout(() => {
      const scrollContainer = document.getElementById('comboScrollContainer');
      if (scrollContainer) {
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
      }
    }, 100);
  }

  removeComboRow(index: number) {
    const confirmDialog: ConfirmDialogModel = new ConfirmDialogModel(
      'Confirm Delete',
      'Are you sure you want to remove this combo option?'
    );
    confirmDialog.yesButtonCaption = 'Delete';
    confirmDialog.noButtonCaption = 'Cancel';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '400px',
      data: confirmDialog
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.comboOptions[index].id) {
          // Mark as deleted for existing records
          this.comboOptions[index].is_deleted = "1";
        } else {
          // Remove new records completely
          this.comboOptions.splice(index, 1);
        }
        this.comboOptions = [...this.comboOptions];
      }
    });
  }

  private _filterSaleItems(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.saleItemsCustomization
      .filter(item => item.name.toLowerCase().includes(filterValue))
      .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  }

  private _filterCopyItems(value: string | any): any[] {
    if (!this.copyItems || this.copyItems.length === 0) {
      return [];
    }

    // If value is an object (selected item), return all items sorted
    if (typeof value === 'object' && value !== null) {
      return this.copyItems.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    }

    // If value is null or undefined, return all items sorted
    if (!value) {
      return this.copyItems.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    }

    const filterValue = value.toString().toLowerCase();
    return this.copyItems
      .filter(item =>
        item.name.toLowerCase().includes(filterValue) ||
        item.code.toLowerCase().includes(filterValue)
      )
      .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  }

  displayCopyItem = (item: any) => {
    return item ? item.name : '';
  }

  save(): void {
    console.log('=== SAVE METHOD CALLED ===');
    console.log('Form value:', this.editForm.value);
    console.log('Form valid:', this.editForm.valid);
    console.log('Form errors:', this.getFormValidationErrors());

    this.saleItemInfo.sub_class_id = this.editForm.get('sub_class_id')?.value;
    if (this.editForm.valid) {
      console.log('✅ Form is valid - proceeding with API call');
      this.editForm.markAllAsTouched();
      Object.assign(this.saleItemInfo, this.editForm.value);
      // Format customization data for API
      if (this.customizationOptions && this.customizationOptions.length > 0) {
        (this.saleItemInfo as any).customizations = this.customizationOptions
          .filter(opt => opt.customization_option_id) // Only include options with valid IDs
          .map(opt => ({
            customization_option_id: opt.customization_option_id,
            display_order: opt.display_order || 10,
            is_valid: opt.is_valid ? 1 : 0
          }));
      } else {
        (this.saleItemInfo as any).customizations = [];
      }

      // Format combo data for API
      if (this.comboOptions && this.comboOptions.length > 0) {
        this.saleItemInfo.combo = this.comboOptions
          .filter(combo => combo.combo_option_id) // Only include combos with valid IDs
          .map(combo => ({
            combo_option_id: combo.combo_option_id,
            display_order: combo.display_order,
            is_valid: combo.is_valid ? 1 : 0
          }));
      } else {
        this.saleItemInfo.combo = [];
      }

      // Remove old properties that might conflict
      delete (this.saleItemInfo as any).customization;

      // Debug logs to check what's happening
      console.log('Is Edit Mode:', this.isEditMode);
      console.log('SaleItemInfo ID before API call:', this.saleItemInfo.id);
      console.log('Has ID property:', this.saleItemInfo.hasOwnProperty('id'));

      // For new items, ensure no id property exists
      if (!this.isEditMode && (!this.saleItemInfo.id || this.saleItemInfo.id === 0)) {
        delete (this.saleItemInfo as any).id;
        console.log('Removed ID for new item - calling ADD API');
      } else {
        console.log('Keeping ID for existing item - calling UPDATE API');
      }

      console.log('Final payload being sent:', this.saleItemInfo); // Debug log

      this.saleItemService.update(this.saleItemInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            this.isFormDirty = false;
            const isNewItem = !this.isEditMode;
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: `The ${this.saleItemInfo.name} has been ${isNewItem ? 'created' : 'updated'} successfully.`
            }
            this.snackBarService.openSnackBar(snckBarData);
          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
            this.router.navigate(['/product/sale-items']);
          }
        },
        error: (error) => {
          let snackBarData: SnackBarData = {
            message: 'Failed to save. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    } else {
      console.log('❌ Form is NOT valid - marking all fields as touched');
      this.editForm.markAllAsTouched();
    }
  }

  private getFormValidationErrors() {
    let formErrors: any = {};
    Object.keys(this.editForm.controls).forEach(key => {
      const controlErrors = this.editForm.get(key)?.errors;
      if (controlErrors) {
        formErrors[key] = controlErrors;
      }
    });
    return formErrors;
  }

  loadStockList(): void {
    let requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 100, offset: 0 },
        },
        sort: [{ column: "code", order: "asc" }],
      },
    };

    this.saleItemService.getStocksList(requestData).subscribe(
      (response: {
        data: any;
        status: string;
        message: any;
      }) => {
        if (response.status === "SUCCESS") {
          this.stock_item_id = response.data.stocks;
          this.filteredOptions = this.stock_item_id;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      }
    );
  }

  loadKitchenList(): void {
    let requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 100, offset: 0 },
        },
        sort: [{ column: "code", order: "asc" }],
      },
    };

    this.saleItemService.getkitchenList(requestData).subscribe(
      (response: {
        data: any;
        status: string;
        message: any;
      }) => {
        if (response.status === "SUCCESS") {
          this.kitchen = response.data.kitchens;

          // Initialize kitchen autocomplete
          this.filteredKitchen = this.kitchenControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filterKitchen(value || ''))
          );

          // Initialize autocomplete controls if editing existing item
          this.initializeAutocompleteControls();
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      }
    );
  }

  loaditemClassesList(): void {
    this.saleItemService.getAllItemClasses().subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS' && response.data) {
          this.itemClasses = response.data.item_classes.sort((a: any, b: any) => (a.name || '').localeCompare(b.name || ''));

          // let snackBarData: SnackBarData = {
          //   message: 'All item classes are now available for selection',
          //   title: 'Updated',
          //   type: 'success'
          // };
          // this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to load all item classes',
          title: 'Failed!!!',
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  loadTaxList(): void {
    let requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 100, offset: 0 },
        },
        sort: [{ column: "code", order: "asc" }],
      },
    };

    this.saleItemService.getTaxList(requestData).subscribe(
      (response: {
        data: any;
        status: string;
        message: any;
      }) => {
        if (response.status === "SUCCESS") {
          this.tax = response.data;

          // Initialize tax autocomplete
          this.filteredTax = this.taxControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filterTax(value || ''))
          );

          // Auto-select tax if mandatory and only one option available
          this.autoSelectTaxIfSingle();

          // Initialize autocomplete controls if editing existing item
          this.initializeAutocompleteControls();
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      }
    );
  }
  loadUomList(): void {
    let requestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: 50,
            offset: 0
          }
        },
        sort: [{ column: "u.name", order: "asc" }]
      }
    };

    this.saleItemService.getUomList(requestData).subscribe(
      (response: {
        data: any;
        status: string;
        message: any;
      }) => {
        if (response.status === "SUCCESS") {
          this.uomList = response.data.uoms;

          // Initialize UOM autocomplete
          this.filteredUom = this.uomControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filterUom(value || ''))
          );

          // Auto-select UOM if mandatory and only one option available
          this.autoSelectUomIfSingle();

          // Initialize autocomplete controls if editing existing item
          this.initializeAutocompleteControls();
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      }
    );
  }

  saleItemList() {
    let requestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: 50,
            offset: 0
          }
        },
        sort: []
      }
    };

    this.saleItemService.getList(requestData).subscribe(
      (response: {
        data: any;
        status: string;
        message: any;
      }) => {
        if (response.status === "SUCCESS") {
          this.saleItemsCustomization = response.data.items;
          // console.log(this.saleItemsCustomization)
          // this.filteredOptions = this.stock_item_id;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      }
    );
  }

  displayItemType = (itemTypeId: any): string => {
    if (!this.itemTypes) return '';
    const found = this.itemTypes.find(t => t.id === itemTypeId || t.id == itemTypeId);
    return found ? found.name : '';
  }

  displayItemClass = (itemClassId: any): string => {
    if (!this.itemClasses) return '';
    const found = this.itemClasses.find((t: any) => t.id === itemClassId || t.id == itemClassId);
    return found ? found.name : '';
  }

  getTitle(): string {
    return (this.saleItemInfo.id == 0 || !this.saleItemInfo.id) ? "New Sale Item" : "Editing : " + this.saleItemInfo.name;
  }

  displayOptionName = (id: any) => {
    const item = this.saleItemsCustomization.find(opt => String(opt.id) === String(id));
    return item ? item.name : '';
  }

  displayComboOptionName = (id: any) => {
    const item = this.saleItemsCombo.find(opt => String(opt.id) === String(id));
    return item ? item.name : '';
  }

  loadGroupItems(): void {
    let requestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: 1000, // Increase limit to get more items
            offset: 0
          }
        },
        sort: [
          {
            "column": "name",
            "order": "asc"
          }
        ]
      }
    };


    this.saleItemService.getGroupItemList(requestData).subscribe(
      (response: {
        data: any;
        status: string;
        message: any;
      }) => {
        if (response.status === "SUCCESS") {
          this.groupItems = response.data.group_items || [];
          // console.log('=== Group Items Loaded Successfully ===');
          // console.log('Loaded groupItems:', this.groupItems);
          // console.log('groupItems count:', this.groupItems.length);

          // Initialize group items autocomplete
          this.filteredGroupItems = this.groupItemControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filterGroupItems(value || ''))
          );

          // Filter items with item_type=2 and id != current saleItemId
          const currentSaleItemId = this.saleItemInfo?.id || 0;
          this.copyItems = this.groupItems.filter(item =>
            item.item_type == 2 && item.id != currentSaleItemId
          );

          console.log('Copy items after filtering:', currentSaleItemId);

          // Initialize copy items autocomplete AFTER data is loaded
          this.filteredCopyItems = this.copyItemControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filterCopyItems(value || ''))
          );

          // Initialize autocomplete controls if editing existing item
          this.initializeAutocompleteControls();
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      }
    );
  }

  get showHotItemsConfiguration(): boolean {
    const groupItemId = this.editForm.get('group_item_id')?.value;
    return !groupItemId; // Show hot items config when no group is selected
  }

  get hotItemsDisabled(): boolean {
    const groupItemId = this.editForm.get('group_item_id')?.value;
    return !!groupItemId; // Disable hot items fields when group is selected
  }

  get isCustomizableItem(): boolean {
    const itemType = this.editForm.get('item_type')?.value;
    const normalizedType = typeof itemType === 'string' ? parseInt(itemType) : itemType;
    // console.log('Original:', itemType, 'Type:', typeof(itemType), 'Normalized:', normalizedType);
    return normalizedType === 2;
  }

  get isComboItem(): boolean {
    const itemType = this.editForm.get('item_type')?.value;
    const normalizedType = typeof itemType === 'string' ? parseInt(itemType) : itemType;
    return normalizedType === 3;
  }

  get isEditMode(): boolean {
    return !!(this.saleItemInfo && this.saleItemInfo.id);
  }

  onItemTypeSelected(event: any) {
    const selectedItemType = event.option.value;
    this.editForm.get('item_type')?.setValue(selectedItemType);
    // console.log('Item type selected:', selectedItemType);
  }

  get totalComboPrice(): number {
    if (!this.comboOptions || this.comboOptions.length === 0) {
      return 0;
    }

    return this.comboOptions
      .filter(combo => combo.is_deleted !== "1") // Exclude deleted items
      .reduce((total, combo) => {
        const discountPrice = parseFloat(combo.discount_price) || 0;
        return total + discountPrice;
      }, 0);
  }

  onCopyItemSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedItem = event.option.value;
    // Just store the selected item, don't make API call yet
    this.copyItemControl.setValue(selectedItem);
  }

  onCopyButtonClicked(): void {
    const selectedItem = this.copyItemControl.value;
    if (selectedItem && typeof selectedItem === 'object' && selectedItem.id) {
      // Show confirmation dialog
      const confirmDialog: ConfirmDialogModel = new ConfirmDialogModel(
        'dev.csms.mojosoft.work says',
        `This action will overwrite the customization option of ${selectedItem.name}. Are you sure?`
      );
      confirmDialog.yesButtonCaption = 'OK';
      confirmDialog.noButtonCaption = 'Cancel';

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: '400px',
        data: confirmDialog
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.copyCustomizationFromItem(selectedItem.id);
        }
      });
    } else {
      let snackBarData: SnackBarData = {
        type: 'warn',
        title: 'No Selection',
        message: 'Please select an item to copy from first'
      };
      this.snackBarService.openSnackBar(snackBarData);
    }
  }

  copyCustomizationFromItem(itemId: number): void {
    this.saleItemService.getcustomizationBySaleItem(itemId).subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS' && response.data.customizations && response.data.customizations.length > 0) {
          // Clear existing customization options
          this.customizationOptions = [];
          this.optionNameControl = [];
          this.filteredSaleItems = [];

          // Copy customization data from selected item
          const copiedCustomization = response.data.customizations.map((opt: any) => ({
            customization_option_id: opt.customization_option_id,
            displayName: opt.display_name || opt.name,
            defaultOptions: opt.option_value_name || '',
            display_order: opt.display_order || 10,
            is_valid: opt.is_valid === 1 || opt.is_valid === true
          }));

          this.bindCustomizationOptions(copiedCustomization);

          let snackBarData: SnackBarData = {
            type: 'success',
            title: 'Copied',
            message: `${copiedCustomization.length} customization options copied successfully`
          };
          this.snackBarService.openSnackBar(snackBarData);
        } else {
          let snackBarData: SnackBarData = {
            type: 'warn',
            title: 'No Data',
            message: 'Selected item has no customization data to copy'
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to copy data from selected item',
          title: 'Failed!!!',
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  onGroupItemSelected(event: any): void {
    const selectedGroupItemId = event.value;
    if (selectedGroupItemId) {
      // Group item selected - get item class for that group
      this.getItemClassByGroupId(selectedGroupItemId);
      this.disableHotItemControls();
    } else {
      // No group item selected - only reload all item classes for new items
      if (!this.isEditMode) {
        this.getAllItemClasses();
      }
      this.enableHotItemControls();
    }
  }

  private disableHotItemControls(): void {
    console.log('Disabling hot item controls');
    const hotItemControls = [
      'is_hot_item_1', 'hot_item_1_display_order',
      'is_hot_item_2', 'hot_item_2_display_order',
      'is_hot_item_3', 'hot_item_3_display_order',
      'is_dt_item', 'dt_display_order', 'dt_menu_number'
    ];

    hotItemControls.forEach(controlName => {
      const control = this.editForm.get(controlName);
      if (control) {
        control.disable();
      }
    });
  }

  private enableHotItemControls(): void {
    console.log('Enabling hot item controls');
    // Enable checkboxes first
    const checkboxControls = ['is_hot_item_1', 'is_hot_item_2', 'is_hot_item_3', 'is_dt_item'];
    checkboxControls.forEach(controlName => {
      const control = this.editForm.get(controlName);
      if (control) {
        control.enable();
        console.log(`Enabled checkbox: ${controlName}`);
      }
    });

    // Enable input fields based on their corresponding checkbox states
    const pairs = [
      { checkbox: 'is_hot_item_1', fields: ['hot_item_1_display_order'] },
      { checkbox: 'is_hot_item_2', fields: ['hot_item_2_display_order'] },
      { checkbox: 'is_hot_item_3', fields: ['hot_item_3_display_order'] },
      { checkbox: 'is_dt_item', fields: ['dt_display_order', 'dt_menu_number'] }
    ];

    pairs.forEach(pair => {
      const checkboxEnabled = this.editForm.get(pair.checkbox)?.value;
      pair.fields.forEach(fieldName => {
        const control = this.editForm.get(fieldName);
        if (control) {
          if (checkboxEnabled) {
            control.enable();
            console.log(`Enabled input: ${fieldName} (checkbox checked)`);
          } else {
            control.disable();
            console.log(`Disabled input: ${fieldName} (checkbox unchecked)`);
          }
        }
      });
    });
  }

  getItemClassByGroupId(groupItemId: number): void {
    this.saleItemService.getItemClassByGroupId(groupItemId).subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS' && response.data && response.data.item_classes && response.data.item_classes.length > 0) {
          const itemClassData = response.data.item_classes[0]; // Get the first item class
          console.log('Item class response data:', itemClassData); // Debug log

          // Don't overwrite itemClasses array, just update the form control
          this.editForm.patchValue({
            sub_class_id: itemClassData.item_id
          });

          console.log('Updated sub_class_id to:', itemClassData.item_id); // Debug log
          console.log('Form value after update:', this.editForm.get('sub_class_id')?.value); // Debug log

          // let snackBarData: SnackBarData = {
          //   type: 'success',
          //   title: 'Updated',
          //   message: `Item class updated to: ${itemClassData.name}`
          // };
          // this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        console.error('Error getting item class by group ID:', error);
        let snackBarData: SnackBarData = {
          message: 'Failed to get item class data for selected group item',
          title: 'Failed!!!',
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  getAllItemClasses(): void {
    // Only execute for new items (not in edit mode)
    if (!this.isEditMode) {
      this.saleItemService.getAllItemClasses().subscribe({
        next: (response: any) => {
          if (response.status === 'SUCCESS' && response.data) {
            this.itemClasses = response.data.item_classes.sort((a: any, b: any) => (a.name || '').localeCompare(b.name || ''));

            // let snackBarData: SnackBarData = {
            //   message: 'All item classes are now available for selection',
            //   title: 'Updated',
            //   type: 'success'
            // };
            // this.snackBarService.openSnackBar(snackBarData);
          }
        },
        error: (error) => {
          let snackBarData: SnackBarData = {
            message: 'Failed to load all item classes',
            title: 'Failed!!!',
            type: 'error'
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    }
  }

  clearItemClass(): void {
    this.editForm.get('sub_class_id')?.setValue(null);
    this.editForm.get('sub_class_id')?.markAsTouched();
  }

  clearItemType(): void {
    this.editForm.get('item_type')?.setValue(null);
    this.editForm.get('item_type')?.markAsTouched();
  }

  clearGroupItem(): void {
    this.editForm.get('group_item_id')?.setValue(null);
    this.editForm.get('group_item_id')?.markAsTouched();
    this.groupItemControl.setValue(null);
    this.onGroupItemSelected({ value: null });
  }

  clearUom(): void {
    this.editForm.get('uom_id')?.setValue(null);
    this.editForm.get('uom_id')?.markAsTouched();
    this.uomControl.setValue(null);
  }

  clearKitchen(): void {
    this.editForm.get('kitchen_id')?.setValue(null);
    this.editForm.get('kitchen_id')?.markAsTouched();
    this.kitchenControl.setValue(null);
  }

  clearTax(): void {
    this.editForm.get('tax_id')?.setValue(null);
    this.editForm.get('tax_id')?.markAsTouched();
    this.taxControl.setValue(null);
  }

  clearCopyItem(): void {
    this.copyItemControl.setValue(null);
  }

  // Autocomplete selection handlers
  onGroupItemAutocompleteSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedItem = event.option.value;
    this.editForm.get('group_item_id')?.setValue(selectedItem.id);
    this.editForm.get('group_item_id')?.markAsTouched();
    this.onGroupItemSelected({ value: selectedItem.id });
  }

  onTaxSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedItem = event.option.value;
    this.editForm.get('tax_id')?.setValue(selectedItem.id);
    this.editForm.get('tax_id')?.markAsTouched();
  }

  onUomSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedItem = event.option.value;
    this.editForm.get('uom_id')?.setValue(selectedItem.id);
    this.editForm.get('uom_id')?.markAsTouched();
  }

  onKitchenSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedItem = event.option.value;
    this.editForm.get('kitchen_id')?.setValue(selectedItem.id);
    this.editForm.get('kitchen_id')?.markAsTouched();
  }

  clearOptionName(index: number): void {
    this.optionNameControl[index].setValue(null);
    this.customizationOptions[index].customization_option_id = null;
    this.customizationOptions[index].displayName = '';
    this.customizationOptions[index].defaultOptions = '';
    this.customizationOptions[index].option_for = '';
  }

  clearComboOption(index: number): void {
    this.comboOptions[index].combo_option_id = null;
    this.comboOptions[index].combo_option_name = '';
    this.comboOptions[index].display_name = '';
    this.comboOptions[index].option_value_name = '';
    this.comboOptions[index].price = null;
    this.comboOptions[index].is_percentage = 0;
    this.comboOptions[index].price_variance = null;
  }

  // Autocomplete filter methods
  private _filterGroupItems(value: string | any): any[] {
    if (!value) return (this.groupItems || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    const filterValue = typeof value === 'string' ? value.toLowerCase() :
      (value?.name || '').toLowerCase();
    return (this.groupItems || [])
      .filter(item => item.name.toLowerCase().includes(filterValue))
      .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  }

  private _filterTax(value: string | any): any[] {
    if (!value) return (this.tax || []).sort((a: any, b: any) => (a.name || '').localeCompare(b.name || ''));
    const filterValue = typeof value === 'string' ? value.toLowerCase() :
      (value?.name || '').toLowerCase();
    return (this.tax || [])
      .filter((item: any) => item.name.toLowerCase().includes(filterValue))
      .sort((a: any, b: any) => (a.name || '').localeCompare(b.name || ''));
  }

  private _filterUom(value: string | any): any[] {
    if (!value) return (this.uomList || []).sort((a: any, b: any) => (a.name || '').localeCompare(b.name || ''));
    const filterValue = typeof value === 'string' ? value.toLowerCase() :
      (value?.name || '').toLowerCase();
    return (this.uomList || [])
      .filter((item: any) => item.name.toLowerCase().includes(filterValue))
      .sort((a: any, b: any) => (a.name || '').localeCompare(b.name || ''));
  }

  private _filterKitchen(value: string | any): any[] {
    if (!value) return (this.kitchen || []).sort((a: any, b: any) => (a.name || '').localeCompare(b.name || ''));
    const filterValue = typeof value === 'string' ? value.toLowerCase() :
      (value?.name || '').toLowerCase();
    return (this.kitchen || [])
      .filter((item: any) => item.name.toLowerCase().includes(filterValue))
      .sort((a: any, b: any) => (a.name || '').localeCompare(b.name || ''));
  }

  // Display functions for autocomplete
  displayGroupItem(item: any): string {
    return item ? item.name : '';
  }

  displayTax(item: any): string {
    return item ? item.name : '';
  }

  private autoSelectTaxIfSingle(): void {
    // Check if tax field is mandatory and there's no existing value
    const taxControl = this.editForm.get('tax_id');
    const hasExistingValue = taxControl?.value;

    // Only auto-select for new items (not editing) and when field is empty
    if (!this.isEditMode && !hasExistingValue && this.tax && this.tax.length === 1) {
      const singleTax = this.tax[0];
      console.log('Auto-selecting single tax option:', singleTax.name);

      // Set both the form control and the autocomplete control
      this.editForm.get('tax_id')?.setValue(singleTax.id);
      this.taxControl.setValue(singleTax);

      // Mark as touched to show validation state
      this.editForm.get('tax_id')?.markAsTouched();
      this.taxControl.markAsTouched();

      // Update form validity
      this.editForm.get('tax_id')?.updateValueAndValidity();
      this.taxControl.updateValueAndValidity();
    }
  }

  private autoSelectUomIfSingle(): void {
    // Check if UOM field is mandatory and there's no existing value
    const uomControl = this.editForm.get('uom_id');
    const hasExistingValue = uomControl?.value;

    // Only auto-select for new items (not editing) and when field is empty
    if (!this.isEditMode && !hasExistingValue && this.uomList && this.uomList.length === 1) {
      const singleUom = this.uomList[0];
      console.log('Auto-selecting single UOM option:', singleUom.name);

      // Set both the form control and the autocomplete control
      this.editForm.get('uom_id')?.setValue(singleUom.id);
      this.uomControl.setValue(singleUom);

      // Mark as touched to show validation state
      this.editForm.get('uom_id')?.markAsTouched();
      this.uomControl.markAsTouched();

      // Update form validity
      this.editForm.get('uom_id')?.updateValueAndValidity();
      this.uomControl.updateValueAndValidity();
    }
  }

  displayUom(item: any): string {
    return item ? item.name : '';
  }

  displayKitchen(item: any): string {
    return item ? item.name : '';
  }

  // Combo option autocomplete methods
  getComboOptionDisplayName(comboOptionId: any): string {
    if (!comboOptionId) return '';
    const option = this.availableComboOptions.find(opt => opt.combo_option_id === comboOptionId);
    return option ? option.name : '';
  }

  onComboOptionInput(event: any, index: number): void {
    const filterValue = event.target.value.toLowerCase();
    this.filteredComboOptions = this.availableComboOptions.filter(option =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  onComboOptionAutocompleteSelected(event: any, index: number): void {
    const selectedOption = event.option.value;
    if (selectedOption) {
      this.comboOptions[index].combo_option_id = selectedOption.combo_option_id;
      this.comboOptions[index].combo_option_name = selectedOption.name;
      this.comboOptions[index].display_name = selectedOption.display_name;
      this.comboOptions[index].option_value_name = selectedOption.option_value_name;
      this.comboOptions[index].price = selectedOption.price;
      this.comboOptions[index].is_percentage = selectedOption.is_percentage;
      this.comboOptions[index].price_variance = selectedOption.price_variance;
    }
  }

  setupInitialHotItemControlStates(): void {
    const pairs = [
      { checkbox: 'is_hot_item_1', fields: ['hot_item_1_display_order'] },
      { checkbox: 'is_hot_item_2', fields: ['hot_item_2_display_order'] },
      { checkbox: 'is_hot_item_3', fields: ['hot_item_3_display_order'] },
      { checkbox: 'is_dt_item', fields: ['dt_display_order', 'dt_menu_number'] }
    ];

    // Console log group item data
    // const groupItemId = this.editForm.get('group_item_id')?.value;
    // console.log(groupItemId);
    // Set initial state
    pairs.forEach(pair => {
      const enabled = this.editForm.get(pair.checkbox)?.value;
      pair.fields.forEach(field => {
        const control = this.editForm.get(field);
        if (enabled) {
          control?.enable();
        } else {
          control?.disable();
        }
      });
    });

    // Set up listeners for dynamic changes
    pairs.forEach(pair => {
      this.editForm.get(pair.checkbox)?.valueChanges.subscribe(enabled => {
        pair.fields.forEach(field => {
          const control = this.editForm.get(field);
          if (enabled) {
            control?.enable();
          } else {
            control?.disable();
          }
        });
      });
    });
  }

  initializeAutocompleteControls(): void {
    // Initialize group item control
    if (this.saleItemInfo.group_item_id && this.groupItems) {
      const selectedGroupItem = this.groupItems.find((item: any) => item.id == this.saleItemInfo.group_item_id);
      if (selectedGroupItem) {
        this.groupItemControl.setValue(selectedGroupItem);
      }
    }
    const groupItemId = this.editForm.get('group_item_id')?.value;
    console.log('Group Item ID:', groupItemId);
    if (groupItemId) {
      this.disableHotItemControls();
    } else {
      this.enableHotItemControls();
    }
    // Initialize tax control
    if (this.saleItemInfo.tax_id && this.tax) {
      const selectedTax = this.tax.find((item: any) => item.id == this.saleItemInfo.tax_id);
      if (selectedTax) {
        this.taxControl.setValue(selectedTax);
      }
    }

    // Initialize UOM control
    if (this.saleItemInfo.uom_id && this.uomList) {
      const selectedUom = this.uomList.find((item: any) => item.id == this.saleItemInfo.uom_id);
      if (selectedUom) {
        this.uomControl.setValue(selectedUom);
      }
    }

    // Initialize kitchen control
    if (this.saleItemInfo.kitchen_id && this.kitchen) {
      const selectedKitchen = this.kitchen.find((item: any) => item.id == this.saleItemInfo.kitchen_id);
      if (selectedKitchen) {
        this.kitchenControl.setValue(selectedKitchen);
      }
    }
  }

  onGroupItemAddClick(): void {
    const dialogRef = this.dialog.open(GroupItemEditPopupComponent, {
      width: '800px',
      maxHeight: '90vh',
      data: {
        groupItemId: 0, // 0 indicates new item
        groupName: ''   // Empty name for new item
      },
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Add the new group item to the list and update the autocomplete
        this.addNewGroupItemToList(result);
      }
    });
  }

  onGroupItemEditClick(): void {
    const groupItemId = this.editForm.get('group_item_id')?.value;
    if (!groupItemId) {
      return;
    }

    const selectedGroupItem = this.groupItems.find((item: any) => item.id == groupItemId);
    const groupName = selectedGroupItem ? selectedGroupItem.name : '';

    const dialogRef = this.dialog.open(GroupItemEditPopupComponent, {
      width: '800px',
      maxHeight: '90vh',
      data: {
        groupItemId: groupItemId,
        groupName: groupName
      },
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Refresh the group items list and update the autocomplete
        this.refreshGroupItemsAfterEdit(result);
      }
    });
  }

  private addNewGroupItemToList(newItem: any): void {
    // Create the new group item object with proper structure
    const newGroupItem = {
      id: newItem.id, // This should be the ID returned from the server
      name: newItem.name,
      code: newItem.code,
      sub_class_id: newItem.sub_class_id,
      display_order: newItem.display_order,
      bg_color: newItem.bg_color,
      fg_color: newItem.fg_color,
      bg_color2: newItem.bg_color2,
      use_multi_color: newItem.use_multi_color,
      item_type: newItem.item_type || 1, // Use the actual item_type from the response
      // Add any other required properties that group items should have
      is_hot_item_1: newItem.is_hot_item_1,
      hot_item_1_display_order: newItem.hot_item_1_display_order,
      hot_item_1_menu_number: newItem.hot_item_1_menu_number,
      is_hot_item_2: newItem.is_hot_item_2,
      hot_item_2_display_order: newItem.hot_item_2_display_order,
      hot_item_2_menu_number: newItem.hot_item_2_menu_number,
      is_hot_item_3: newItem.is_hot_item_3,
      hot_item_3_display_order: newItem.hot_item_3_display_order,
      hot_item_3_menu_number: newItem.hot_item_3_menu_number,
      is_dt_item: newItem.is_dt_item,
      dt_display_order: newItem.dt_display_order,
      dt_menu_number: newItem.dt_menu_number
    };

    // Add the new item to the groupItems array
    this.groupItems.push(newGroupItem);

    // Sort the array by display_order or name to maintain proper order
    this.groupItems.sort((a, b) => {
      const orderA = a.display_order || 999999;
      const orderB = b.display_order || 999999;
      if (orderA !== orderB) {
        return orderA - orderB;
      }
      return (a.name || '').localeCompare(b.name || '');
    });

    // Update copy items array since it's derived from group items
    const currentSaleItemId = this.saleItemInfo?.id || 0;
    this.copyItems = this.groupItems.filter(item =>
      item.item_type == 2 && item.id != currentSaleItemId
    );

    // Reinitialize filtered observables to include the new item
    this.filteredGroupItems = this.groupItemControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterGroupItems(value || ''))
    );

    this.filteredCopyItems = this.copyItemControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterCopyItems(value || ''))
    );

    // Automatically select the new group item
    // Set the form control first
    this.editForm.get('group_item_id')?.setValue(newGroupItem.id);
    this.editForm.get('group_item_id')?.markAsTouched();

    // Use setTimeout to ensure proper change detection
    setTimeout(() => {
      // Then set the autocomplete control to the full object
      this.groupItemControl.setValue(newGroupItem);

      // Trigger group item selection logic
      this.onGroupItemSelected({ value: newGroupItem.id });
    }, 100);

    // Show success message
    let snackBarData: SnackBarData = {
      type: 'success',
      title: 'Added',
      message: `New group item "${newItem.name}" created successfully and selected`
    };
    this.snackBarService.openSnackBar(snackBarData);
  }

  private refreshGroupItemsAfterEdit(updatedItem: any): void {
    // Find and update the item in the groupItems array
    const index = this.groupItems.findIndex((item: any) => item.id == updatedItem.id);
    if (index !== -1) {
      // Update the existing item with new data
      this.groupItems[index] = {
        ...this.groupItems[index],
        name: updatedItem.name,
        code: updatedItem.code,
        sub_class_id: updatedItem.sub_class_id,
        display_order: updatedItem.display_order,
        bg_color: updatedItem.bg_color,
        fg_color: updatedItem.fg_color,
        bg_color2: updatedItem.bg_color2,
        use_multi_color: updatedItem.use_multi_color
      };

      // Update the autocomplete control with the updated item
      const currentSelection = this.groupItemControl.value;
      if (currentSelection && currentSelection.id == updatedItem.id) {
        this.groupItemControl.setValue({
          ...currentSelection,
          name: updatedItem.name,
          code: updatedItem.code
        });
      }

      // Also update copy items array since it's derived from group items
      const currentSaleItemId = this.saleItemInfo?.id || 0;
      this.copyItems = this.groupItems.filter(item =>
        item.item_type == 2 && item.id != currentSaleItemId
      );

      // Reinitialize filtered observables to reflect updates
      this.filteredGroupItems = this.groupItemControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filterGroupItems(value || ''))
      );

      this.filteredCopyItems = this.copyItemControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filterCopyItems(value || ''))
      );

      // Show success message
      let snackBarData: SnackBarData = {
        type: 'success',
        title: 'Updated',
        message: 'Group item updated successfully.'
      };
      this.snackBarService.openSnackBar(snackBarData);
    }
  }
}